/**
 * week-days.ts — tên thứ và khoá ngày cục bộ, dùng chung cho mọi lưới tuần.
 *
 * Không React, không side effect. Ở `lib/` chứ không nằm trong một feature vì
 * ba màn dùng chúng (Lịch chụp, Ca lễ tân, Đăng ký ca) và một component chung
 * (`components/shift-grid`) cũng dùng — một component chung đi mượn helper của
 * MỘT feature là dựng ngược chiều phụ thuộc.
 *
 * `features/schedule/calendar.ts` re-export lại từ đây, nên mã cũ không đổi.
 */

export const DAY_NAMES = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"] as const;

/**
 * Tên thứ tiếng Việt của một ngày CỤ THỂ.
 *
 * Lấy từ chính ngày, không lấy theo vị trí cột: chỉ số cột chỉ đúng khi khoảng
 * xem bắt đầu vào thứ Hai, mà khoảng tuỳ chọn của Lịch chụp bắt đầu ngày nào
 * cũng được.
 */
export function dayNameOf(date: Date): string {
  return DAY_NAMES[(date.getDay() + 6) % 7]!;
}

/**
 * Khoá ngày "YYYY-MM-DD" theo giờ ĐỊA PHƯƠNG.
 *
 * Không dùng `toISOString()`: nó đổi sang UTC nên ở múi giờ Việt Nam mọi thời
 * điểm trước 07:00 sẽ lùi về ngày hôm trước — lịch nhảy sai một ngày mỗi sáng.
 */
export function toLocalDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Thứ Hai của tuần chứa ngày "YYYY-MM-DD", cũng ở dạng "YYYY-MM-DD".
 *
 * Đọc chuỗi bằng `new Date(y, m - 1, d)` chứ không `new Date("YYYY-MM-DD")`:
 * dạng sau hiểu chuỗi là nửa đêm UTC, nên ở múi giờ âm nó lùi về hôm trước và
 * Chủ nhật bị đếm sang tuần trước.
 */
export function mondayOfLocalDate(dateKey: string): string {
  const [y, m, d] = dateKey.slice(0, 10).split("-").map(Number);
  const date = new Date(y!, m! - 1, d!);
  date.setDate(date.getDate() - ((date.getDay() + 6) % 7));
  return toLocalDate(date);
}
